module.exports = __webpack_public_path__ + "static/scape-formation-i_acrylic-on-canvas-105x105in-2016-5af330f7374b6eb9ae377f9ff3f08224.jpg";